import NAME from "./constants";

export const GET_ROWS = NAME + "/GET_ROWS";
export const GET_ROWS_FULFILLED = NAME + "/GET_ROWS_FULFILLED";
export const GET_ROWS_REJECTED = NAME + "/GET_ROWS_REJECTED";

export const CREATE = NAME + "/CREATE";
export const CREATE_FULFILLED = NAME + "/CREATE_FULFILLED";
export const CREATE_REJECTED = NAME + "/CREATE_REJECTED";

export const MODIFY = NAME + "/MODIFY";
export const MODIFY_FULFILLED = NAME + "/MODIFY_FULFILLED";
export const MODIFY_REJECTED = NAME + "/MODIFY_REJECTED";

export const DELETE = NAME + "/DELETE";
export const DELETE_FULFILLED = NAME + "/DELETE_FULFILLED";
export const DELETE_REJECTED = NAME + "/DELETE_REJECTED";

export const DUPLICATE = NAME + "/DUPLICATE";
export const DUPLICATE_FULFILLED = NAME + "/DUPLICATE_FULFILLED";
export const DUPLICATE_REJECTED = NAME + "/DUPLICATE_REJECTED";

export const EXPORT = NAME + "/EXPORT";
export const EXPORT_FULFILLED = NAME + "/EXPORT_FULFILLED";
export const EXPORT_REJECTED = NAME + "/EXPORT_REJECTED";

export const IMPORT = NAME + "/IMPORT";
export const IMPORT_FULFILLED = NAME + "/IMPORT_FULFILLED";
export const IMPORT_REJECTED = NAME + "/IMPORT_REJECTED";

export const GENERATE = NAME + "/GENERATE";
export const GENERATE_FULFILLED = NAME + "/GENERATE_FULFILLED";
export const GENERATE_REJECTED = NAME + "/GENERATE_REJECTED";

export const IMPLEMENT = NAME + "/IMPLEMENT";
export const IMPLEMENT_FULFILLED = NAME + "/IMPLEMENT_FULFILLED";
export const IMPLEMENT_REJECTED = NAME + "/IMPLEMENT_REJECTED";

export const TEST_QUERY = NAME + "/TEST_QUERY";
export const TEST_QUERY_FULFILLED = NAME + "/TEST_QUERY_FULFILLED";
export const TEST_QUERY_REJECTED = NAME + "/TEST_QUERY_REJECTED";

export const CLEAR_STATE = NAME + "/CLEAR_STATE";
